import React, { useEffect, useRef, useState } from "react";
import "./PrintReceipt.css";
import logo from "../../../logo.svg";
import Barcode from "react-barcode";
import * as Icons from "heroicons-react";
import { useParams } from "react-router-dom";
import {
  itemVat,
  itemVatTotal,
  toDecimal,
} from "../../Utility/PosCalculations";
import { format } from "date-fns";
import { useSaleQuery } from "../../../services/saleApi";
import { notify } from "../../Utility/Notify";
import { useReactToPrint } from "react-to-print";
import { signInUser } from "../../Utility/Auth";
import { resolvePhotoUrl } from "../../Utility/resolvePhotoUrl";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import { useSettingsQuery } from "../../../services/settingsApi";
import { useUserQuery } from "../../../services/userApi";

const PrintReceiptById = React.forwardRef(({ ...props }) => {
  // Fetch settings
  // console.log("Settings::>>", settings)
  const printContent = useRef();
  const [bill, setBill] = useState({});
  const { invoiceId } = props;
  const { id } = useParams();
  const [whName, setWhName] = useState("aamarDokan");
  const auth = signInUser();
  const { aamarId, storeSettings } = auth || {};
  const { data: dbSettings } = useSettingsQuery(aamarId, { skip: !aamarId });
  const activeSettings = dbSettings || storeSettings;
  const dbStorePhoto = dbSettings?.storePhoto || dbSettings?.photo || dbSettings?.data?.storePhoto || dbSettings?.data?.photo;
  const storeLogoSrc = dbStorePhoto ? resolvePhotoUrl(dbStorePhoto, "") : "";

  const { data: wh, refetch } = useWarehouseQuery(bill?.warehouse);
  useEffect(() => {
    if (bill?.warehouse) {
      refetch();
    }
  }, [bill?.warehouse, refetch]);

  useEffect(() => {
    if (wh) {
      setWhName(wh?.name);
      refetch();
    }
  }, [wh, refetch]);
  // console.log('warehouse',wh)

  let invoice_id = id || invoiceId;
  if ((!invoice_id || invoice_id === "43587136450871" || invoice_id === "last") && aamarId) {
    invoice_id = `last?aamarId=${aamarId}`;
  } else if (!invoice_id) {
    invoice_id = "last";
  }

  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [deliveryPhone, setDeliveryPhone] = useState("");
  const [delivery, setDelivery] = useState(false);
  const { data, isSuccess } = useSaleQuery(invoice_id);
  console.log("DATA", data);
  const handlePrint = useReactToPrint({
    content: () => printContent.current,
    onAfterPrint: () => {
      notify("Bill Printed Successful!", "success");
    },
    // onBeforePrint: handleOnBeforeGetContent,
  });

  useEffect(() => {
    if (isSuccess) {
      if (data) {
        setBill(data);
      }
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (data?.delivery) {
      setDelivery(true);
      setDeliveryAddress(
        data?.delivery?.address ? data?.delivery?.address : ""
      );
      setDeliveryPhone(data?.delivery?.phone ? data?.delivery?.phone : "");
    }
  }, [data]);

  const rawBillerId =
    typeof bill?.billerId === "string"
      ? bill?.billerId
      : bill?.billerId?._id;

  const isCurrentAuthBiller = Boolean(
    rawBillerId &&
      (rawBillerId === auth?.id ||
        rawBillerId === auth?._id ||
        rawBillerId === auth?.userId)
  );

  const shouldFetchUser = Boolean(
    rawBillerId &&
      !bill?.billerId?.name &&
      !isCurrentAuthBiller &&
      /^[0-9a-fA-F]{24}$/.test(rawBillerId)
  );

  const { data: billerUserData } = useUserQuery(rawBillerId, {
    skip: !shouldFetchUser,
  });

  const billerDisplayName =
    bill?.billerId?.name ||
    bill?.billerName ||
    bill?.biller?.name ||
    (typeof bill?.biller === "string" ? bill?.biller : "") ||
    billerUserData?.name ||
    (isCurrentAuthBiller ? auth?.name : "") ||
    bill?.updateUser?.name ||
    (typeof bill?.billerId === "string" && !/^[0-9a-fA-F]{24}$/.test(bill.billerId)
      ? bill.billerId
      : "") ||
    auth?.name ||
    auth?.username ||
    "N/A";

  // console.log(invoice_id);
  // console.log("BILLS",bill);
  const onClose = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  return (
    <div className="print-wrapper pt-5 mt-5 mb-5">
      <div className="d-flex justify-content-center">
        <button className="btn btn-dark me-3" onClick={handlePrint}>
          <Icons.PrinterOutline className="me-2" size={18} /> Print Bill
        </button>
        <button className="btn btn-outline-dark" onClick={onClose}>
          <Icons.X className="me-2" size={18} />
          Cancle
        </button>
      </div>
      <div className=" print-area" ref={printContent}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {storeLogoSrc ? (
                <p className="text-center">
                  <img
                    src={storeLogoSrc}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    alt=""
                    width="180"
                    className="logo"
                  />
                </p>
              ) : null}
              <h5 className="text-center">
                <b>{storeSettings?.storeName || "Aamar Dokan"}</b>
              </h5>
              <p className="text-center info header">
                <i>
                  BIN: {storeSettings?.binNumber || " no-Bin-Number"}{" "}
                  {storeSettings?.vatPercentage ? (
                    <span>| Mushak {storeSettings?.vatPercentage} </span>
                  ) : (
                    ""
                  )}
                </i>
              </p>
              <p className="text-center info invoice">
                Invoice No: {bill?.invoiceId}
              </p>
              {/* {console.log(bill?.customerId)} */}
              <p className="info pt-2">
                Phone: {bill?.customerId?.phone || "01810-000000"}
                <span className="float-end">
                  Date:{" "}
                  {bill?.createdAt &&
                    format(new Date(bill?.createdAt), "MM-dd-yyyy")}
                </span>
              </p>
              <p className="info pt-2">
                Customer: {bill?.customerId?.name || "Walkaway Customer"}
                <span className="float-end">
                  {bill?.createdAt
                    ? format(new Date(bill.createdAt), "h:mm a")
                    : "Time not available"}
                </span>
              </p>
              <p className="info pt-2">
                Biller: {billerDisplayName}
                <span className="float-end">
                  Outlet: <b>{whName}</b>
                </span>
              </p>
              {delivery && (
                <>
                  <p className="info pt-2">
                    Delivery Address:{deliveryAddress}
                  </p>
                  <p className="info pt-2">Delivery Phone:{deliveryPhone}</p>
                </>
              )}

              <p className="text-center pt-2 order_details">ORDER DETAILS</p>
              <table className="table px-2 d-flex-table">
                <thead>
                  <tr>
                    <td colSpan="3">Item</td>
                    <td>Qty</td>
                    <td>Rate</td>
                    <td></td>
                    <td className="text-end">Total</td>
                  </tr>
                </thead>
                <tbody>
                  {/* {console.log(bill.products)} */}
                  {bill?.products ? (
                    bill?.products.map((item) => (
                      <tr className="d-print-table-row" key={item.id}>
                        <td
                          colSpan="3"
                          style={{
                            textTransform: "capitalize",
                            fontSize: ".7em",
                          }}
                        >
                          {item?.name.toLowerCase().substring(0, 30)}
                          {item?.name.length > 30 ? "..." : ""}
                        </td>
                        <td>{item?.qty}</td>
                        <td>{item?.mrp}</td>
                        <td>
                          {/* {itemVat(
                            item?.qty && item?.vat,
                            item?.qty,
                            item?.mrp
                          ).toFixed(2)} */}
                        </td>
                        <td>
                          <span className="float-end">
                            {itemVatTotal(
                              item?.vat,
                              item?.qty,
                              item?.mrp
                            ).toFixed(2)}
                            {/* {item?.total} */}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">No Product in Purchase cart</td>
                    </tr>
                  )}
                  {bill?.returnProducts?.length > 0 && (
                    <>
                      <tr>
                        <th colSpan={3}>
                          <b>Return Products</b>
                        </th>
                        <td colSpan={5} className="text-end">
                          <b>Ref Invoice id:</b>{" "}
                          {bill?.returnInvoice?.invoiceId}
                        </td>
                      </tr>
                      {bill?.returnProducts?.map((item) => (
                        <tr className="d-print-table-row" key={item.id}>
                          <td
                            colSpan="3"
                            style={{
                              textTransform: "capitalize",
                              fontSize: ".7em",
                            }}
                          >
                            {item?.name.toLowerCase().substring(0, 30)}
                            {item?.name.length > 30 ? "..." : ""}
                          </td>
                          <td>{item?.qty}</td>
                          <td>{item?.mrp}</td>
                          <td>
                            {/* {itemVat(
                              item?.qty && item?.vat,
                              item?.qty,
                              item?.mrp
                            ).toFixed(2)} */}{" "}
                            -
                          </td>
                          <td>
                            <span className="float-end">
                              {(item?.qty * item?.mrp).toFixed(2)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
              {/* Total Item */}
              <p className="bill-inf border-bottom border-bottom-dashed">
                Total Item: <span className="float-end">{bill?.totalItem}</span>
              </p>
              {/* Return Item */}
              {bill?.returnCal?.totalItem > 0 && (
                <p className="bill-info border-bottom border-bottom-dashed">
                  Return Item:
                  <span className="float-end">
                    {bill?.returnCal?.totalItem}
                  </span>
                </p>
              )}
              {/* 01. Total */}
              <p className="bill-info border-bottom border-bottom-dashed">
                Total:
                <span className="float-end">
                  {parseFloat(bill?.total)?.toFixed(2)}
                </span>
              </p>
              {/* 02. Discount */}
              <p className="bill-info border-bottom border-bottom-dashed">
                Discount: <span className="float-end">{bill?.discount}</span>
              </p>
              {bill?.promo_discount > 0 ? (
                <p className="bill-info">
                  Promo Discount:{" "}
                  <span className="float-end">
                    {bill?.promo_discount?.toFixed(2)}
                  </span>
                </p>
              ) : (
                <span>None</span>
              )}
              {/* 03. Vat */}
              {/* <p className="bill-info border-bottom border-bottom-dashed">
                Vat:{" "}
                <span className="float-end">
                  {(
                    bill?.vat -
                    (bill?.returnCal?.vatAmount > 0 &&
                      bill?.returnCal?.vatAmount)
                  )?.toFixed(2)}
                </span>
              </p> */}
              {/* 04. Return Total */}
              {bill?.returnCal?.total > 0 && (
                <p className="bill-info border-bottom border-bottom-dashed">
                  Return Total:{" "}
                  <span className="float-end">
                    {bill?.returnCal?.total?.toFixed(2)}
                  </span>
                </p>
              )}
              {/* 05. Gross Total */}
              <p className="bill-info border-bottom border-bottom-dashed">
                Gross Total:{" "}
                <span className="float-end">
                  {parseFloat(bill?.grossTotal)?.toFixed(2)}
                </span>
              </p>
              {/* 06. Gross Total Round */}
              <p className="bill-info border-bottom border-bottom-dashed">
                Gross Total (Rounding):
                <span className="float-end">
                  {parseFloat(bill?.grossTotalRound)?.toFixed(2)}
                </span>
              </p>
              {bill?.paidAmount?.cash > 0 && (
                <p className="bill-info border-bottom border-bottom-dashed">
                  Received Cash:
                  <span className="float-end">{bill?.paidAmount?.cash}</span>
                </p>
              )}
              {bill?.paidAmount?.card?.amount > 0 && (
                <p className="bill-info">
                  Received{" "}
                  {bill?.paidAmount?.card?.name
                    ? bill?.paidAmount?.card?.name
                    : "Visa"}{" "}
                  Card :
                  <span className="float-end">
                    {bill?.paidAmount?.card.amount}
                  </span>
                </p>
              )}
              {bill?.paidAmount?.mfs?.amount > 0 && (
                <p className="bill-info border-bottom border-bottom-dashed">
                  Received {bill?.paidAmount?.mfs?.name}:
                  <span className="float-end">
                    {bill?.paidAmount?.mfs?.amount}
                  </span>
                </p>
              )}
              {bill?.paidAmount?.point > 0 && (
                <p className="bill-info border-bottom border-bottom-dashed">
                  Received Point:
                  <span className="float-end">{bill?.paidAmount?.point}</span>
                </p>
              )}

              {(() => {
                const grossAmount =
                  parseFloat(bill?.grossTotalRound ?? bill?.grossTotal ?? 0) ||
                  0;
                let receivedAmount =
                  parseFloat(bill?.totalReceived ?? 0) || 0;
                if (!receivedAmount && bill?.paidAmount) {
                  receivedAmount =
                    (Number(bill.paidAmount.cash) || 0) +
                    (Number(bill.paidAmount.card?.amount) || 0) +
                    (Number(bill.paidAmount.mfs?.amount) || 0);
                }
                const isDueBill = Boolean(
                  bill?.due === true ||
                    bill?.due === "true" ||
                    bill?.billType === "due" ||
                    grossAmount > receivedAmount
                );
                let dueAmount = 0;
                if (isDueBill && grossAmount > receivedAmount) {
                  dueAmount = grossAmount - receivedAmount;
                } else if (
                  isDueBill &&
                  bill?.changeAmount !== undefined &&
                  bill?.changeAmount !== null &&
                  Number(bill?.changeAmount) < 0
                ) {
                  dueAmount = Math.abs(Number(bill?.changeAmount));
                }

                const displayChange =
                  !isDueBill && receivedAmount > grossAmount
                    ? receivedAmount - grossAmount
                    : Math.max(0, parseFloat(bill?.changeAmount ?? 0) || 0);

                return (
                  <>
                    <p className="bill-info border-bottom border-bottom-dashed">
                      Total Received:
                      <span className="float-end">
                        {receivedAmount.toFixed(2)}
                      </span>
                    </p>
                    {dueAmount > 0 && (
                      <p className="bill-info border-bottom border-bottom-dashed text-danger">
                        <b>Due Amount:</b>{" "}
                        <span className="float-end">
                          {dueAmount.toFixed(2)}
                        </span>
                      </p>
                    )}
                    <p className="bill-info border-bottom border-bottom-dashed">
                      Change Amount:{" "}
                      <span className="float-end">
                        {displayChange.toFixed(2)}
                      </span>
                    </p>
                  </>
                );
              })()}
              <p className="bill-info text-center ">
                Previous Point: {bill?.point?.old} | New Point :
                {bill?.point?.new}
              </p>
              <p className="nb text-center">
                N.B: <i>Sold products will not be returned after 24 hours</i>
                <br />
                All Product Price included VAT & Tax
              </p>
              <p className="text-center bar-code">
                {bill?.invoiceId && (
                  <Barcode
                    value={bill?.invoiceId}
                    height={60}
                    width={2}
                    fontSize={12}
                  />
                )}
              </p>
              <p className="text-center info footer">
                {storeSettings?.websiteUrl || " "}
              </p>
              <p className="text-center info">
                <b>
                  {storeSettings?.phone && (
                    <>Hot Line:{storeSettings?.phone} </>
                  )}
                </b>
              </p>
              <p className="text-center info ">
                <i>Thank you for shopping with us.</i>
              </p>
              <p className="text-center info pt-1" style={{ fontSize: "0.8em" }}>
                Proudly Powered by Aamar Dokan
                <br />
                Helpline: 01760-322672
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PrintReceiptById;
